import axios from 'axios'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		authors: null,
		posts: null
	},
	actions: {
		getAuthors: function(context) {
			// Grab authors
			axios.get('http://nport.vincentsnaggdesign.com/wp-json/wp/v2/users')
			.then((response) => {
				context.commit('storeAuthors', response.data)
			})
		},
		getPosts: function(context) {
			return new Promise((resolve, reject) => {	
				if(context.state.posts) {
					resolve()
				}
				else {
					// Grab posts from WP-API
					axios.get('http://nport.vincentsnaggdesign.com/wp-json/wp/v2/posts?_embed')
					.then((response) => {
						context.commit('storePosts', response.data)
						resolve()
					}).catch((error) => {
						reject(error);
					});
				}
			})
		}
	},
	mutations: {
		storeAuthors(state, response) {
			state.authors = response
		},
		storePosts(state, response) {
			state.posts = response
		}
	}

})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js